import { useCallback } from 'react'
import { useSearchParams } from 'router-v6'

// `?version=<phlo_connections.id>` is the single source of truth for which flow
// version the builder renders. Present → that historical version is shown
// read-only on the live canvas; absent → the editable current version. The
// dropdown only ever sets it for NON-active versions (it clears for the active
// one), so a present param always means "viewing history". (SER-5591)
export const VERSION_PARAM = 'version'

export const useVersionView = () => {
  const [searchParams, setSearchParams] = useSearchParams()
  const raw = searchParams.get(VERSION_PARAM)
  // Accept only a positive-integer id (phlo_connections.id); anything else — missing,
  // non-numeric, 0, negative, float, hex/exponent — is treated as "no version" so the
  // canvas stays on the live version instead of firing a doomed fetch. This is the
  // SINGLE parse point; every consumer reads viewingVersionId, never the raw param.
  const parsed = raw && /^\d+$/.test(raw) ? Number(raw) : Number.NaN
  const viewingVersionId = Number.isInteger(parsed) && parsed > 0 ? parsed : null
  const isViewingHistorical = viewingVersionId != null

  // Pass an id to view that version, or null to return to the current version.
  const viewVersion = useCallback(
    (id: number | null) => {
      setSearchParams((prev) => {
        const next = new URLSearchParams(prev)
        if (id == null) next.delete(VERSION_PARAM)
        else next.set(VERSION_PARAM, String(id))
        return next
      })
    },
    [setSearchParams],
  )

  return { viewingVersionId, isViewingHistorical, viewVersion }
}
